import React from 'react';
import { useOutletContext } from 'react-router-dom';
import SubscriptionPage from '../components/subscription/SubscriptionPage';

const SubscriptionPageWrapper = () => {
  const handleSubscribe = (planId) => {
    console.log('Subscribe to:', planId);
    // Will be connected to backend payment API
  };

  return <SubscriptionPage currentPlan="free" onSubscribe={handleSubscribe} />;
};

export default SubscriptionPageWrapper;
